import { defineStore } from 'pinia'
import { ref } from 'vue'
import { smsApi, type SmsTemplateDto } from '@/api/sms'

export const useSmsStore = defineStore('sms', () => {
  const smsTemplates = ref<SmsTemplateDto[]>([])
  const isLoaded = ref(false)
  let fetchPromise: Promise<void> | null = null

  const fetchSms = async () => {
    if (isLoaded.value) return
    if (fetchPromise) return fetchPromise

    fetchPromise = (async () => {
      try {
        const response = await smsApi.getSmsTemplates()
        smsTemplates.value = (response as unknown as SmsTemplateDto[]) || []
        isLoaded.value = true
      } catch (error) {
        console.error('載入簡訊範本失敗:', error)
        smsTemplates.value = []
      }
    })()

    try {
      await fetchPromise
    } finally {
      fetchPromise = null
    }
  }

  return { smsTemplates, isLoaded, fetchSms }
})
